module.exports = __webpack_public_path__ + "img/fer-bordeaux.db69c544.svg";